import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const dataApi = createApi({
  reducerPath: "dataApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_BASE_URL }),
  endpoints: (builder) => ({
    fetchData: builder.mutation({
      query: ({ action, path }) => {
        const formData = new FormData();
        formData.append("action", action);
        return {
          url: path,
          method: "POST",
          body: formData,
        };
      },
      transformResponse: (response) => ({
        data: response.data || [],
        totalCount: response.totalCount || 0,
        success: response.success || false,
        message: response.message,
      }),
    }),
  }),
});

export const { useFetchDataMutation } = dataApi;
